import { useLayoutEffect, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import { NavContext } from "./context/NavContext";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import * as StyledNav from "./Styled.Nav";
import LogoStanley from "./Logos/LogoStanley";
import LogoStan from "./Logos/LogoStan";
import LogoS from "./Logos/LogoS";

export default function Navbar() {
  const stickyRef = useRef(null);
  const { menuState, handleNav, closeNav, debounce } = useContext(NavContext);

  //Create variables of DOM nodes of Icon
  const IconToggleButton = useRef(null);
  const iconHamburgerWrapper = useRef(null);
  const iconCrossWrapper = useRef(null);
  const menuLayer = useRef(null);
  const buttonDisabled = useRef(false);
  const hamburgerToCrossTimeline = useRef(null);
  const crossToHamburgerTimeline = useRef(null);
  const revealMenuTimeline = useRef(null);
  const concealMenuTimeline = useRef(null);
  const playDuration = useRef(null);
  const reverseDuration = useRef(null);
  const revealDuration = useRef(null);
  const concealDuration = useRef(null);

  //Create variables of DOM notes of locations
  const location = useLocation();
  const currentPath = location.pathname;
  const prevPathRef = useRef(location.pathname);

  // useGSAP hamburgerToCross animation
  useGSAP(
    () => {
      hamburgerToCrossTimeline.current = gsap.timeline({
        paused: true,
        defaults: {
          ease: "power3.inOut",
        },
        onStart: () => {
          const spanHamburgers = document.querySelectorAll(".spanHamburger");
          spanHamburgers.forEach((spanHamburger) => {
            console.log(
              "useGSAP(() => { onStart - hamburgerToCrossTimeline - .spanHamburgers set x:0 }"
            );
            gsap.set(spanHamburger, {
              x: 0,
            });
          });
          console.log(
            "useGSAP(() => { onStart - hamburgerToCrossTimeline - .spanCross1 set x:25 y:-25 }"
          );
          gsap.set(".spanCross1", {
            x: 25,
            y: -25,
          });
          console.log(
            "useGSAP(() => { onStart - hamburgerToCrossTimeline - .spanCross2 set x:-25 y:-25 }"
          );
          gsap.set(".spanCross2", {
            x: -25,
            y: -25,
          });
        },
        onComplete: () => {
          // Get the progress of the playhead
          const progress = hamburgerToCrossTimeline.current.progress();
          // Check if the timeline is playing in reverse
          const isReversed = hamburgerToCrossTimeline.current.reversed();
          if (!isReversed) {
            console.log(
              "useGSAP(() => { onComplete hamburgerToCrossTimeline.play() - Progress:",
              progress,
              "}"
            );
          }
        },
      });
      hamburgerToCrossTimeline.current
        .fromTo(
          ".spanHamburger",
          {
            x: 0,
          },
          {
            x: -24,
            duration: 0.3,
            stagger: {
              amount: -0.15,
            },
          }
        )
        .fromTo(
          ".spanCross1",
          {
            x: 25,
            y: -25,
          },
          {
            duration: 0.3,
            css: {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(-45deg)",
            },
          }
        )
        .fromTo(
          ".spanCross2",
          {
            x: -25,
            y: -25,
          },
          {
            duration: 0.3,
            css: {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(45deg)",
            },
          },
          "0.6"
        );

      // Get total time for play
      playDuration.current = hamburgerToCrossTimeline.current.totalDuration();

      if (menuState.initial && !menuState.menuOpen) {
        hamburgerToCrossTimeline.current.pause(0);
      } else if (menuState.clicked && menuState.menuOpen) {
        hamburgerToCrossTimeline.current.play(0);
        console.log(
          "useGSAP(() => { EXECUTE - hamburgerToCrossTimeline.play() Total duration:",
          playDuration.current,
          "}"
        );
      }
    },
    { dependencies: [menuState], scope: IconToggleButton }
  );

  // useGSAP crossToHamburger animation
  useGSAP(
    () => {
      crossToHamburgerTimeline.current = gsap.timeline({
        paused: true,
        defaults: {
          ease: "power3.inOut",
        },
        onStart: () => {
          const spanHamburgers = document.querySelectorAll(".spanHamburger");
          spanHamburgers.forEach((spanHamburger) => {
            console.log(
              "useGSAP(() => { onStart - crossToHamburgerTimeline - .spanHamburgers set x:-24 }"
            );
            gsap.set(spanHamburger, {
              x: -24,
            });
          });
          console.log(
            "useGSAP(() => { onStart - crossToHamburgerTimeline - .spanCross1 set top:50% left:50% transform:translate(-50%, -50%) rotate(-45deg) }"
          );
          gsap.set(".spanCross1", {
            css: {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(-45deg)",
            },
          });
          console.log(
            "useGSAP(() => { onStart - crossToHamburgerTimeline - .spanCross2 set top:50% left:50% transform:translate(-50%, -50%) rotate(45deg) }"
          );
          gsap.set(".spanCross2", {
            css: {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(45deg)",
            },
          });
        },
        onComplete: () => {
          // Get the progress of the playhead
          const progress = crossToHamburgerTimeline.current.progress();
          // Check if the timeline is playing in reverse
          const isReversed = crossToHamburgerTimeline.current.reversed();
          if (!isReversed) {
            console.log(
              "useGSAP(() => { onComplete crossToHamburgerTimeline.play() - Progress:",
              progress,
              "}"
            );
          }
        },
      });
      crossToHamburgerTimeline.current
        .fromTo(
          ".spanCross2",
          {
            css: {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(45deg)",
            },
          },
          {
            duration: 0.3,
            x: -25,
            y: -25,
          }
        )
        .fromTo(
          ".spanCross1",
          {
            css: {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(-45deg)",
            },
          },
          {
            duration: 0.3,
            x: 25,
            y: -25,
          },
          "0.15"
        )
        .fromTo(
          ".spanHamburger",
          {
            x: -24,
          },
          {
            x: 0,
            duration: 0.3,
            stagger: {
              amount: 0.15,
            },
          }
        );

      // Get total time for reverse
      reverseDuration.current =
        crossToHamburgerTimeline.current.totalDuration();

      if (menuState.initial && !menuState.menuOpen) {
        crossToHamburgerTimeline.current.pause(1);
      } else if (!menuState.clicked && !menuState.menuOpen) {
        crossToHamburgerTimeline.current.play(0);
        console.log(
          "useGSAP(() => { EXECUTE - crossToHamburgerTimeline.play() Total duration:",
          reverseDuration.current,
          "}"
        );
      }
    },
    { dependencies: [menuState], scope: IconToggleButton }
  );

  // useGSAP dropmenu animation
  useGSAP(
    () => {
      const menuItems = document.querySelectorAll(".menuItem");
      const menuReveals = document.querySelectorAll(".menuReveal");
      revealMenuTimeline.current = gsap.timeline({
        paused: true,
        defaults: {
          ease: "power3.inOut",
        },
        onComplete: () => {
          // Get the progress of the playhead
          const progress = revealMenuTimeline.current.progress();
          // Check if the timeline is playing in play()
          const isPlayed = revealMenuTimeline.current.play();
          if (isPlayed) {
            console.log(
              "useGSAP(() => { onComplete revealMenuTimeline.play(). Progress:",
              progress,
              "}"
            );
            // console.log(`GSAP - revealMenuTimeline Progress: ${progress}`);
          }
        },
        onStart: () => {
          if (menuLayer.current) {
            console.log(
              "useGSAP(() => { onStart - revealMenuTimeline - menuLayer.current set display:none height:100vh }"
            );
            gsap.set(menuLayer.current, {
              css: {
                display: "block",
                height: "100vh",
              },
            });
          }
          menuItems.forEach((menuItem) => {
            console.log(
              "useGSAP(() => { onStart - revealMenuTimeline - .menuItem set y:100 yPercent:-50 }"
            );
            gsap.set(menuItem, {
              css: {
                y: "100",
                xPercent: "-50",
              },
            });
          });
          menuReveals.forEach((menuReveal) => {
            console.log(
              "useGSAP(() => { onStart - revealMenuTimeline - .menuReveal set height:0 }"
            );
            gsap.set(menuReveal, {
              css: {
                height: "0",
              },
            });
          });
        },
      });
      concealMenuTimeline.current = gsap.timeline({
        paused: true,
        defaults: {
          ease: "power3.inOut",
        },
        onComplete: () => {
          menuReveals.forEach((menuReveal) => {
            console.log(
              "useGSAP(() => { onComplete - concealMenuTimeline - .menuReveal set height:0 }"
            );
            gsap.set(menuReveal, {
              css: {
                height: "0",
              },
            });
          });
          menuItems.forEach((menuItem) => {
            console.log(
              "useGSAP(() => { onComplete - concealMenuTimeline - .menuItem set y:100 yPercent:-50 }"
            );
            gsap.set(menuItem, {
              css: {
                y: "100",
                xPercent: "-50",
              },
            });
          });
          if (menuLayer.current) {
            console.log(
              "useGSAP(() => { onComplete - concealMenuTimeline - menuLayer.current set display:none height:0 }"
            );
            gsap.set(menuLayer.current, {
              css: {
                display: "none",
                height: "0",
              },
            });
          }
          // Get the progress of the playhead
          const progress = concealMenuTimeline.current.progress();
          console.log(
            "useGSAP(() => { onComplete - concealMenuTimeline.play() - Progress:",
            progress,
            "}"
          );
        },
        onStart: () => {
          if (menuLayer.current) {
            console.log(
              "useGSAP(() => { onStart - concealMenuTimeline - menuLayer set display:block height:100vh }"
            );
            gsap.set(menuLayer.current, {
              css: {
                display: "block",
                height: "100vh",
              },
            });
          }
          menuReveals.forEach((menuReveal) => {
            console.log(
              "useGSAP(() => { onStart - concealMenuTimeline - .menuReveal set height:100vh }"
            );
            gsap.set(menuReveal, {
              css: {
                height: "100vh",
              },
            });
          });
          menuItems.forEach((menuItem) => {
            console.log(
              "useGSAP(() => { onStart - concealMenuTimeline - .menuItem set xPercent:-50 y:0 }"
            );
            gsap.set(menuItem, {
              xPercent: -50,
              y: 0,
            });
          });
        },
      });

      revealMenuTimeline.current
        .fromTo(
          ".menuReveal",
          {
            css: {
              height: "0",
            },
          },
          {
            duration: 0.8,
            height: "100vh",
            stagger: {
              amount: 0.1,
            },
          }
        )
        .fromTo(
          ".menuItem",
          {
            css: {
              y: "100",
              xPercent: "-50",
            },
          },
          {
            duration: 0.3,
            xPercent: -50,
            y: 0,
            delay: 0.01,
            stagger: {
              amount: 0.1,
            },
          },
          0.1
        );

      concealMenuTimeline.current
        .fromTo(
          ".menuItem",
          {
            xPercent: -50,
            y: 0,
          },
          {
            duration: 0.2,
            xPercent: -50,
            y: -100,
            delay: 0.01,
            stagger: {
              amount: 0.1,
            },
          }
        )
        .fromTo(
          ".menuReveal",
          {
            css: {
              height: "100vh",
            },
          },
          {
            duration: 0.7,
            height: 0,
            stagger: {
              amount: -0.1,
            },
          },
          0.1
        );

      // Get total time for reveal
      revealDuration.current = revealMenuTimeline.current.totalDuration();
      // Get total time for conceal
      concealDuration.current = concealMenuTimeline.current.totalDuration();

      if (menuState.initial && !menuState.menuOpen) {
        revealMenuTimeline.current.pause(0);
        concealMenuTimeline.current.pause(1);
      } else if (menuState.clicked && menuState.menuOpen) {
        revealMenuTimeline.current.play(0);
        console.log(
          "useGSAP(() => { EXECUTE - revealMenuTimeline.play() Total duration:",
          revealDuration.current,
          "}"
        );
      } else if (!menuState.clicked && !menuState.menuOpen) {
        concealMenuTimeline.current.play(0);
        console.log(
          "useGSAP(() => { EXECUTE - concealMenuTimeline.play() Total duration:",
          concealDuration.current,
          "}"
        );
      }
    },
    { dependencies: [menuState], scope: menuLayer }
  );

  useLayoutEffect(() => {
    console.log(
      "Navbar - useLayoutEffect(() => { Current Path:",
      currentPath,
      "})"
    );
    console.log(
      "Navbar - useLayoutEffect(() => { Previous Path:",
      prevPathRef.current,
      "})"
    );
    if (currentPath !== prevPathRef.current) {
      console.log("--- ROUTE CHANGE ---");
      // closeNav();
      // Update the ref with the current path
      prevPathRef.current = currentPath;
    }
  }, [currentPath]);

  return (
    <>
      <StyledNav.LargeNavLogoBar>
        <StyledNav.LogoLink to="/" aria-label="Home">
          <LogoStanley fill={"imperialRed"} />
        </StyledNav.LogoLink>
        <StyledNav.LargeNavLogoBarSlogan as="small">
          Today is the day
        </StyledNav.LargeNavLogoBarSlogan>
      </StyledNav.LargeNavLogoBar>
      <StyledNav.LargeNavContainer ref={stickyRef}>
        <StyledNav.LargeNav as="nav">
          <ul>
            <li>
              <StyledNav.NavLinks
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/"
                onClick={closeNav}
              >
                home
              </StyledNav.NavLinks>
            </li>
            <li>
              <StyledNav.NavLinks
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/articles"
                onClick={closeNav}
              >
                articles
              </StyledNav.NavLinks>
            </li>
            <li>
              <StyledNav.NavLinks
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/about"
                onClick={closeNav}
              >
                about
              </StyledNav.NavLinks>
            </li>
            <li>
              <StyledNav.NavLinks
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/contact"
                onClick={closeNav}
              >
                contact
              </StyledNav.NavLinks>
            </li>
            <li>
              <StyledNav.NavLinks
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/newsletter"
                onClick={closeNav}
              >
                newsletter
              </StyledNav.NavLinks>
            </li>
          </ul>
        </StyledNav.LargeNav>
      </StyledNav.LargeNavContainer>

      <StyledNav.NavLayoutWrapper>
        <StyledNav.MediumNavContainer>
          <StyledNav.MediumNav as="nav">
            <ul>
              <li>
                <StyledNav.MenuToggle
                  as="button"
                  onClick={handleNav}
                  ref={buttonDisabled}
                >
                  {menuState.menuName}
                </StyledNav.MenuToggle>
              </li>
              <li>
                <StyledNav.LogoLink to="/" onClick={closeNav} aria-label="Home">
                  <LogoStan fill={"imperialRed"} />
                </StyledNav.LogoLink>
              </li>
              <li>
                <StyledNav.NavLinks to="/newsletter" onClick={closeNav}>
                  newsletter
                </StyledNav.NavLinks>
              </li>
            </ul>
          </StyledNav.MediumNav>
          <StyledNav.SmallNav as="nav">
            <ul>
              <li>
                <StyledNav.MenuToggle
                  as="button"
                  onClick={handleNav}
                  ref={buttonDisabled}
                >
                  {menuState.menuName}
                </StyledNav.MenuToggle>
              </li>
              <li>
                <StyledNav.LogoLink to="/" onClick={closeNav} aria-label="Home">
                  <LogoS fill={"imperialRed"} />
                </StyledNav.LogoLink>
              </li>
            </ul>
          </StyledNav.SmallNav>
          <StyledNav.XtraSmallNav as="nav">
            <ul>
              <StyledNav.IconToggleButton
                onClick={handleNav}
                ref={IconToggleButton}
              >
                <StyledNav.IconHamburgerWrapper ref={iconHamburgerWrapper}>
                  <StyledNav.IconHamburger className="spanHamburger"></StyledNav.IconHamburger>
                  <StyledNav.IconHamburger className="spanHamburger"></StyledNav.IconHamburger>
                  <StyledNav.IconHamburger className="spanHamburger"></StyledNav.IconHamburger>
                </StyledNav.IconHamburgerWrapper>
                <StyledNav.IconCrossWrapper ref={iconCrossWrapper}>
                  <StyledNav.IconCross className="spanCross1"></StyledNav.IconCross>
                  <StyledNav.IconCross className="spanCross2"></StyledNav.IconCross>
                </StyledNav.IconCrossWrapper>
              </StyledNav.IconToggleButton>
              <li>
                <StyledNav.LogoLink to="/" onClick={closeNav}>
                  <LogoS fill={"imperialRed"} />
                </StyledNav.LogoLink>
              </li>
            </ul>
          </StyledNav.XtraSmallNav>
          {/* DropMenu */}
          <StyledNav.MenuLayer ref={menuLayer}>
            <StyledNav.MenuReveal1 className="menuReveal" />
            <StyledNav.MenuReveal2 className="menuReveal" />
            <StyledNav.DropMenuLinks>
              <StyledNav.DropMenuLinksList as="li">
                <StyledNav.NavLinks
                  className="menuItem"
                  to="/"
                  onClick={closeNav}
                >
                  home
                </StyledNav.NavLinks>
              </StyledNav.DropMenuLinksList>
              <StyledNav.DropMenuLinksList as="li">
                <StyledNav.NavLinks
                  className="menuItem"
                  to="/articles"
                  onClick={closeNav}
                >
                  articles
                </StyledNav.NavLinks>
              </StyledNav.DropMenuLinksList>
              <StyledNav.DropMenuLinksList as="li">
                <StyledNav.NavLinks
                  className="menuItem"
                  to="/about"
                  onClick={closeNav}
                >
                  about
                </StyledNav.NavLinks>
              </StyledNav.DropMenuLinksList>
              <StyledNav.DropMenuLinksList as="li">
                <StyledNav.NavLinks
                  className="menuItem"
                  to="/contact"
                  onClick={closeNav}
                >
                  contact
                </StyledNav.NavLinks>
              </StyledNav.DropMenuLinksList>
              <StyledNav.DropMenuLinksList as="li">
                <StyledNav.NavLinks
                  className="menuItem"
                  to="/newsletter"
                  onClick={closeNav}
                >
                  newsletter
                </StyledNav.NavLinks>
              </StyledNav.DropMenuLinksList>
            </StyledNav.DropMenuLinks>
          </StyledNav.MenuLayer>
        </StyledNav.MediumNavContainer>
      </StyledNav.NavLayoutWrapper>
    </>
  );
}
